import { TableColumnsType } from "antd";
import { TFunction } from "i18next";

export const getStatus = (t: (key: string) => string) => {
  return [
    { value: "new", label: t("Новый") },
    { value: "accepted", label: t("Принято к обработке") },
    { value: "incomplete", label: t("Требуется доработка") },
    { value: "corrected", label: t("Исправлено") },
    { value: "ready_to_payment", label: t("Готов к оплате") },
    { value: "paid", label: t("Оплачен") },
    { value: "payment_confirmed", label: t("Оплата подтверждена") },
    { value: "paid_through_bank", label: t("Оплачен через банк") },
    { value: "paid_by_card", label: t("Оплачен банковской картой") },
    { value: "completed", label: t("Завершенный") },
    { value: "rejected", label: t("Отказ") },
  ];
};

export const statuses: TDropdown[] = [
  { value: "new", label: "Новый" },
  { value: "accepted", label: "Принято к обработке" },
  { value: "incomplete", label: "Требуется доработка" },
  { value: "corrected", label: "Исправлено" },
  { value: "ready_to_payment", label: "Готов к оплате" },
  { value: "paid", label: "Оплачен" },
  { value: "payment_confirmed", label: "Оплата подтверждена" },
  { value: "paid_through_bank", label: "Оплачен через банк" },
  { value: "paid_by_card", label: "Оплачен банковской картой" },
  { value: "completed", label: "Завершенный" },
  { value: "rejected", label: "Отказ" },
];

export const getRole = (t: (key: string) => string) => {
  return [
    { label: t("Водитель"), value: "driver" },
    { label: t("Партнер"), value: "partner" },
    { label: t("Таможенный брокер"), value: "broker" },
    { label: t("Администратор"), value: "admin" },
    { label: t("Региональный представитель"), value: "regional_manager" },
  ];
};

export const getEntityType = (t: (key: string) => string) => {
  return [
    { label: t("Юр.лицо"), value: "legal" },
    { label: t("Физ.лицо"), value: "individual" },
  ];
};

export const getGePosts = (t: (key: string) => string) => {
  return [
    {
      country: t("Грузия - Азербайджан"),
      posts: [
        {
          value: "Krasny_Most-Krasny_Most",
          label: t("Красный Мост (Грузия) - Красный Мост (Азербайджан)"),
        },
        {
          value: "Samtatskaro-Mughanlo",
          label: t("Самтацкаро (Грузия) - Муганлог (Азербайджан)"),
        },
        {
          value: "Gardabani_ZhD-Boykiasik",
          label: t("Гардабани жд (Грузия) - Боикясик (Азербайджан)"),
        },
        {
          value: "Mtkvari-Sadikhli",
          label: t("Мтквари (Грузия) - Садихли (Азербайджан)"),
        },
        {
          value: "Lagodekhi-Mazimgara",
          label: t("Лагодехи (Грузия) - Мазимгара (Азербайджан)"),
        },
      ],
    },
    {
      country: t("Грузия - Армения"),
      posts: [
        {
          value: "Sadakhlo-Bagratashen",
          label: t("Садахло (Грузия) - Баграташен (Армения)"),
        },
        {
          value: "Sadakhlo_ZhD-Ayrum",
          label: t("Садахло ЖД (Грузия) - Аирум (Армения)"),
        },
        {
          value: "Guguti-Gogaran",
          label: t("Гугути (Грузия) - Гогаран (Армения)"),
        },
        {
          value: "Akhkerp-Privolnoye",
          label: t("Ахкерп (Грузия) - Приволное (Армения)"),
        },
        {
          value: "Ninotsminda-Bavra",
          label: t("Ниноцминда (Грузия) - Бавра (Армения)"),
        },
      ],
    },
    {
      country: t("Грузия - Россия"),
      posts: [
        {
          value: "Kazbeg-Verkhny_Lars",
          label: t("Казбег (Грузия) - Верхный Ларс (Россия)"),
        },
      ],
    },
    {
      country: t("Грузия - Турция"),
      posts: [
        {
          value: "Vale-Turk_Gozlu",
          label: t("Вале (Грузия) - Турк Гозлу (Турция)"),
        },
        {
          value: "Sarpi-Sarpi",
          label: t("Сарпи (Грузия) - Сарпи (Турция)"),
        },
        {
          value: "Kartsakh-Aktash",
          label: t("Карцах (Грузия) - Акташ (Турция)"),
        },
        {
          value: "Kartsakh_Akhalkalaki_ZhD-KanbazisDemir_Ipekyolu_ZhD",
          label: t(
            "Карцах-Ахалкалаки жд (Грузия) - Канбазис/демир ипекиолу жд (Турция)",
          ),
        },
      ],
    },
    {
      country: t("Порты"),
      posts: [
        {
          value: "Poti_Georgia",
          label: t("Порт Поти (Грузия)"),
        },
        {
          value: "Batumi_Georgia",
          label: t("Порт Батуми (Грузия)"),
        },
      ],
    },
  ];
};

export type TDropdown = {
  label: string;
  value: string;
};

interface ICountryPosts {
  country: string;
  posts: TDropdown[];
}

export const entity_type: TDropdown[] = [
  { label: "Юр.лицо", value: "legal" },
  { label: "Физ.лицо", value: "individual" },
];

export const roles: TDropdown[] = [
  { label: "Водитель", value: "driver" },
  { label: "Партнер", value: "partner" },
  { label: "Таможенный брокер", value: "broker" },
  { label: "Администратор", value: "admin" },
  { label: "Региональный представитель", value: "regional_manager" },
];

export const getFilesTypes = (t: (key: string) => string) => {
  return [
    { value: "invoice", label: t("Инвойс (документ сопровождающий груз)") },
    {
      value: "transport",
      label: t("Транспортный документ (CMR, Bill of Lading,...)"),
    },
    {
      value: "customs_declaration_files",
      label: t("Экспортная/ Транзитная декларация"),
    },
    { value: "supporting", label: t("Прочие документы") },
    { value: "tech_passport_file", label: t("Техпаспорт") },
    { value: "drivers_passport", label: t("Паспорт водителя") },
  ];
};

export const file_types: TDropdown[] = [
  { value: "invoice", label: "Инвойс (документ сопровождающий груз )" },
  {
    value: "transport",
    label: "Транспортный документ (CMR, Bill of Lading,...)",
  },
  {
    value: "customs_declaration_files",
    label: "Экспортная/ Транзитная декларация",
  },
  { value: "supporting", label: "Прочие документы" },
  { value: "tech_passport_file", label: "Техпаспорт" },
  { value: "drivers_passport", label: "Паспорт водителя" },
];

export const custom_posts: ICountryPosts[] = [
  {
    country: "Грузия - Азербайджан",
    posts: [
      {
        value: "Krasny_Most-Krasny_Most",
        label: "Красный Мост (Грузия) - Красный Мост (Азербайджан)",
      },
      {
        value: "Samtatskaro-Mughanlo",
        label: "Самтацкаро (Грузия) - Муганлог (Азербайджан)",
      },
      {
        value: "Gardabani_ZhD-Boykiasik",
        label: "Гардабани жд (Грузия) - Боикясик (Азербайджан)",
      },
      {
        value: "Mtkvari-Sadikhli",
        label: "Мтквари (Грузия) - Садихли (Азербайджан)",
      },
      {
        value: "Lagodekhi-Mazimgara",
        label: "Лагодехи (Грузия) - Мазимгара (Азербайджан)",
      },
    ],
  },
  {
    country: "Грузия - Армения",
    posts: [
      {
        value: "Sadakhlo-Bagratashen",
        label: "Садахло (Грузия) - Баграташен (Армения)",
      },
      {
        value: "Sadakhlo_ZhD-Ayrum",
        label: "Садахло ЖД (Грузия) - Аирум (Армения)",
      },
      {
        value: "Guguti-Gogaran",
        label: "Гугути (Грузия) - Гогаран (Армения)",
      },
      {
        value: "Akhkerp-Privolnoye",
        label: "Ахкерп (Грузия) - Приволное (Армения)",
      },
      {
        value: "Ninotsminda-Bavra",
        label: "Ниноцминда (Грузия) - Бавра (Армения)",
      },
    ],
  },
  {
    country: "Грузия - Россия",
    posts: [
      {
        value: "Kazbeg-Verkhny_Lars",
        label: "Казбег (Грузия) - Верхный Ларс (Россия)",
      },
    ],
  },
  {
    country: "Грузия - Турция",
    posts: [
      {
        value: "Vale-Turk_Gozlu",
        label: "Вале (Грузия) - Турк Гозлу (Турция)",
      },
      {
        value: "Sarpi-Sarpi",
        label: "Сарпи (Грузия) - Сарпи (Турция)",
      },
      {
        value: "Kartsakh-Aktash",
        label: "Карцах (Грузия) - Акташ (Турция)",
      },
      {
        value: "Kartsakh_Akhalkalaki_ZhD-KanbazisDemir_Ipekyolu_ZhD",
        label:
          "Карцах-Ахалкалаки жд (Грузия) - Канбазис/демир ипекиолу жд (Турция)",
      },
    ],
  },
  {
    country: "Порты",
    posts: [
      {
        value: "Poti_Georgia",
        label: "Порт Поти (Грузия)",
      },
      {
        value: "Batumi_Georgia",
        label: "Порт Батуми (Грузия)",
      },
    ],
  },
];

// translations.ts
